import { useMemo } from "react";
import { useSelector } from "react-redux";

export default function(){
    const { companyId, userCompany } = useSelector(state => state.auth);

    return useMemo(() => {
        if (!companyId || !userCompany?.companyData) {
      return null;
    }

    return userCompany.companyData.find(
      c => c.companyId == companyId
    );
    },[companyId, userCompany]);

};